export default __webpack_public_path__ + "static/media/notebookFR.b7a9df7b.pdf";